import { Box, FormControl, Grid, MenuItem, Select } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getBranchList,
  getDepartmentsList,
  getMaterialsList,
} from "../services/api";
import api from "../../../api/api";
import PieChart from "highcharts-react-official";
import Highcharts from "highcharts/highcharts";

export default function MaterialDashboard() {
  const [branchs, setBranchs] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [data, setData] = useState([]);
  const [itemNo, setItemNo] = useState("all");
  const [BranchNo, setBranchsNo] = useState("all");
  const [DepartmentName, setDepartmentName] = useState("all");
  const [loading, setloading] = useState(false);
  const { profile } = useSelector((state) => state.profile);
  const getBranch = async () => {
    const data = await getBranchList();
    setBranchs(data);
  };
  const getDepartments = async () => {
    const data = await getDepartmentsList();
    setDepartments(data);
  };
  // const getBudgetYears = async () => {
  //   const data = await getBudgetYearsList();
  //   setBudgetYears(data);
  // };
  const getMaterials = async () => {
    const data = await getMaterialsList();
    setMaterials(data);
  };
  useEffect(() => {
    getMaterials();
    getBranch();
    getDepartments();
  }, []);

  const handleGetList = useCallback(async () => {
    const url = `material/dashboard/stock`;

    let params = {};

    if (itemNo !== "all") params.itemNo = itemNo;
    if (BranchNo !== "all") params.branchNo = BranchNo;
    if (DepartmentName !== "all") params.departmentName = DepartmentName;
    setloading(true);
    await api
      .get(url, { params: params })
      .then((res) => {
        if (res.status) {
          const data = res.data.result;
          setData(data.data);
          setloading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setloading(false);

        // dispatch(unsetLoading());
      });
  }, [itemNo, BranchNo, DepartmentName]);

  useEffect(() => {
    handleGetList();
  }, [handleGetList]);
  return (
    <div class="container-fluid">
      <Box
        class="col-lg-8 col-md-12 text-left card-content-d"
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          width: "100%",
          marginTop: "10px",
        }}
      >
        {profile?.BranchNo?.BranchNo === "00" && (
          <Box className="col-lg-2 col-md-12 ">
            <Box className="backgroundField" sx={{ marginRight: "20px" }}>
              <FormControl variant="standard" fullWidth>
                <Select
                  value={BranchNo || ""}
                  onChange={(e) => {
                    setBranchsNo(e.target.value);
                  }}
                  disableUnderline
                  MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                >
                  <MenuItem value="all">ศูนย์ทั้งหมด</MenuItem>
                  {branchs?.map((x, i) => (
                    <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
        )}
        <Box className="col-lg-2 col-md-12 ">
          <Box className="backgroundField" sx={{ marginRight: "20px" }}>
            <FormControl variant="standard" fullWidth>
              <Select
                value={DepartmentName || ""}
                onChange={(e) => {
                  setDepartmentName(e.target.value);
                }}
                disableUnderline
                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
              >
                <MenuItem value="all">กลุ่ม/ฝ่ายทั้งหมด</MenuItem>
                {departments?.map((x, i) => (
                  <MenuItem value={x?.DepartmentName}>
                    {x?.DepartmentName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
        <Box className="col-lg-2 col-md-12 ">
          <Box className="backgroundField" sx={{ marginRight: "20px" }}>
            <FormControl variant="standard" fullWidth>
              <Select
                value={itemNo || ""}
                onChange={(e) => {
                  setItemNo(e.target.value);
                }}
                disableUnderline
                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
              >
                <MenuItem value="all">วัสดุทั้งหมด</MenuItem>
                {materials?.map((x, i) => (
                  <MenuItem value={x?.ItemNo}>{x?.ItemName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div class="card-content-d">
            <h2 className="dash-title">พร้อมใช้งาน</h2>
            <Dashboard
              dataDashboard={data.map((x) => [x?.ItemName, x?.Normal]) || []}
            />
          </div>
        </Grid>
        <Grid item md={6} xs={12}>
          <div class="card-content-d">
            <h2 className="dash-title">ชำรุด-รอซ่อม</h2>
            <Dashboard
              dataDashboard={
                data.map((x) => [x?.ItemName, x?.BrokenRepair]) || []
              }
            />
          </div>
        </Grid>
        <Grid item md={6} xs={12}>
          <div class="card-content-d">
            <h2 className="dash-title">ชำรุด-ตัดบัญชี</h2>
            <Dashboard
              dataDashboard={
                data.map((x) => [x?.ItemName, x?.BrokenCutOff]) || []
              }
            />
          </div>
        </Grid>
        <Grid item md={6} xs={12}>
          <div class="card-content-d">
            <h2 className="dash-title">ให้ยืม</h2>
            <Dashboard
              dataDashboard={data.map((x) => [x?.ItemName, x?.LendOut]) || []}
            />
          </div>
        </Grid>
        <Grid item md={6} xs={12}>
          <div class="card-content-d">
                        <h2 className="dash-title">ขอยืม</h2>

            <Dashboard
              dataDashboard={
                data.map((x) => [x?.ItemName, x?.BorrowedIn]) || []
              }
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

const Dashboard = (props) => {
  const { dataDashboard } = props;
  const randomColor = () =>
    "#" +
    Math.floor(Math.random() * 0xffffff)
      .toString(16)
      .padStart(6, "0");

  const data = dataDashboard;
  const options = {
    chart: {
      type: "column",
      // scrollablePlotArea: {
      //     minWidth: 2000,
      //     scrollPositionX: 1
      // }
      zoomType: "x",
    },
    title: {
      text: null,
    },
    subtitle: {
      text: "หน่วย",
      align: "left",
    },

    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      type: "category",
      title: {
        text: null,
      },
      labels: {
        rotation: -45,
        style: {
          fontSize: "13px",
          fontFamily: "Verdana, sans-serif",
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: null,
      },
      labels: {
        formatter: function () {
          return this.value.toLocaleString();
        },
      },
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        color: randomColor(),
      },
      series: {
        borderRadiusTopLeft: 8,
        borderRadiusTopRight: 8,
        color: randomColor(),
      },
    },
    tooltip: {
      pointFormat: "<b>{point.y} หน่วย</b>",
    },
    series: [
      {
        name: "Population",
        data: data,
        type: "column",
      },
    ],
  };
  return (
    <>
      {dataDashboard && <PieChart options={options} highcharts={Highcharts} />}
    </>
  );
};
